import React from 'react'
import "../components/Header_sty.css"
const Header = () => {
  return (
    <>
    <div className = "App">
      <span onClick = {()=>window.scroll(0,0)} className = "header_nav">movie wish</span>
    </div>
    </>
  )
}

export default Header
